import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
// This is done
const PrivacyPolicySummary = () => {
  return (
    <>
      <PrivacyPolicyContainer>
        <h3>Changes to this Policy</h3>
        <p>
          Our Privacy Policy may be updated from time to time to reflect changes
          in our practices, services, or legal requirements. Any changes made
          will be posted on this page with an updated date.
        </p>
        <p>
          For significant changes, we may notify you via email or by displaying
          a prominent notice on our platform. We encourage you to review this
          Privacy Policy periodically to stay informed about how we are
          protecting your information.
        </p>
      </PrivacyPolicyContainer>
      <PrivacyPolicyContainer>
        <h3>Contact Us</h3>
        <p>
          If you have any questions, concerns, or feedback about this Privacy
          Policy or how we handle your personal information, please contact us
          at:
        </p>
        <ul>
          <li>
            Email:{' '}
            <a href="mailto:yodasafetyservices1@outlook.com">
              yodasafetyservices1@outlook.com
            </a>
          </li>
          {/* <li>Contact Form: <a href="/contact-us">Submit a request</a></li> */}
        </ul>
        <p>We aim to respond to all inquiries within 2-3 business days.</p>
      </PrivacyPolicyContainer>
    </>
  );
};

export default PrivacyPolicySummary;
